module.exports = __webpack_public_path__ + "static/polishopa-14385e6403f672a3b7506ca3ba7f62ee.png";